import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { augmentPaging } from '~/infrastructure/paging';
import { ApiServiceBase, API_NAMES } from '~/services/api';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { IAssetMoveDto } from '~/models/modules/Asset/Transactions/Move/assetMoveDto';

@Injectable({ providedIn: 'root' })
export class AssetMoveTransactionsService extends ApiServiceBase {
  FromInventory: any = [];
  constructor(injector: Injector, private http: HttpClient) {
      super(injector);
      this.setBase(API_NAMES.assets);
  }
  getMoveTransactionHistoryGrid(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
        .post<any[]>(this._url(`/grid-data`), model, {
            params,
            observe: 'response',
        })
        .pipe(map(augmentPaging));
  }
  createMoveTransaction(model:IAssetMoveDto){
    return this.client.post<any>(this._url(), model);
  }
  validatePersonLocation(model:IAssetMoveDto){
    return this.client.post<any>(this._url(`/validate-location-person`), model);
  }
  validateCheckSettings(model:IAssetMoveDto){
    return this.client.post<any>(this._url(`/validate-check-settings`), model);
  }


  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/MoveTransaction${v}`);
}
}
